import { createContext, useContext } from 'react';
import { ISchedulingSettings } from '../SchedulingSettingsForm/SchedulingSettingsForm';

export interface ISchedulingSettingsContextState {
  settings: ISchedulingSettings;
  setSettings: (settings: ISchedulingSettings) => void;
}

const SchedulingSettingsContext = createContext<ISchedulingSettingsContextState | null>(null);

export function useSchedulingSettings() {
  const context = useContext(SchedulingSettingsContext);

  if (context === null || context === undefined) {
    throw new Error('useSchedulingSettings must be nested within a SchedulingSettingsContext.Provider.');
  }

  return context;
}

export default SchedulingSettingsContext;
